import type { CreateEnrollmentInput, Enrollment } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { PaginatedResponse } from '@/lib/api'
import { api } from '@/lib/api'

export function useEnrollments() {
  return useQuery({
    queryKey: ['enrollments'],
    queryFn: () => api.getFull<PaginatedResponse<Enrollment>>('/api/enrollments', { limit: '100' }),
  })
}

export function useCreateEnrollment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateEnrollmentInput) => api.post('/api/enrollments', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['enrollments'] })
      qc.invalidateQueries({ queryKey: ['courses'] })
    },
  })
}
